<button mat-icon-button class="md:!hidden ml-2" [matMenuTriggerFor]="mobileMenu">
  <mat-icon style="top: -3px">menu</mat-icon>
</button>

<mat-menu #mobileMenu="matMenu">
  <a mat-menu-item [routerLink]="aboutRoute">About Us</a>
  <a mat-menu-item [routerLink]="privacyRoute">Privacy</a>
  <a mat-menu-item [routerLink]="termRoute">Terms</a>
  <a mat-menu-item [routerLink]="contactRoute">Contact Us</a>
  <a mat-menu-item href="https://apps.shopify.com/goodchart" target="_blank">Live Demo</a>
  <a
    class="!bg-primary !text-text-inverse !text-base !font-semibold"
    mat-menu-item
    href="https://apps.shopify.com/goodchart"
    target="_blank"
  >
    Try
  </a>
</mat-menu>
